import { render } from "./SetDeliveryDataModal.vue?vue&type=template&id=5ba81423"
import script from "./SetDeliveryDataModal.vue?vue&type=script&lang=js"
export * from "./SetDeliveryDataModal.vue?vue&type=script&lang=js"

import "./SetDeliveryDataModal.vue?vue&type=style&index=0&id=5ba81423&lang=css"
script.render = render

export default script